import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import nProgress from 'nprogress'
import "nprogress/nprogress.css"; //引入进度条样式
import "babel-polyfill";
Vue.config.productionTip = false;
import "core-js/stable";
import "regenerator-runtime/runtime";
import "whatwg-fetch";
// import "@/utils/rem.js"; //在main.js中引入rem.js
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
//路由鉴权
//
// (function() {
//   function setRem() {
//     const html = document.documentElement;
//     const width = html.clientWidth;
//     // 假设设计稿宽度为 375px，根字体大小为 100px
//     html.style.fontSize = width / 375 * 100 + 'px';  // 根据设计稿宽度和设备宽度动态设置根字体
//   }
//
//   window.addEventListener('resize', setRem);
//   setRem(); // 页面加载时立即调用一次
// })();
